import React, { useEffect, Component } from 'react';
import Lenis from 'lenis';
import { Toaster } from 'sonner';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Marquee from './components/Marquee';
import Services from './components/Services';
import HowItWorks from './components/HowItWorks';
import Testimonials from './components/Testimonials';
import ServiceAreas from './components/ServiceAreas';
import QuoteForm from './components/QuoteForm';
import Footer from './components/Footer';
import './App.css';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(err) {
    console.error(err);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-ceramic">
          <p className="font-display text-2xl text-obsidian">Something went wrong. Please refresh.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <ErrorBoundary>
      <div className="bg-ceramic text-obsidian">
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <Services />
          <HowItWorks />
          <Testimonials />
          <ServiceAreas />
          <QuoteForm />
        </main>
        <Footer />
        <Toaster position="top-center" richColors />
      </div>
    </ErrorBoundary>
  );
}

export default App;
